// src/pages/Expedite/.../SearchForm/FormFields.js
import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import PF2MDatepicker from '~/components/PF2MDatepicker';
import PF2MSearchSelect from '~/components/PF2MSearchSelect';

export const DateField = ({ name }) => (
  <Field name={name} component={PF2MDatepicker} />
);

export const SelectField = ({ name, options }) => (
  <>
    <Field
      name={name}
      render={({ field, form }) => (
        <PF2MSearchSelect
          placeholder={null}
          {...field}
          onChange={e => form.setFieldValue(field.name, e.target.value, true)}
          style={{ width: '100%' }}
        >
          {options}
        </PF2MSearchSelect>
      )}
    />
    <ErrorMessage
      name={name}
      render={msg => (
        <Typography color="error" variant="caption">
          {msg}
        </Typography>
      )}
    />
  </>
);

export const CheckboxField = ({ name, label, checked }) => (
  <Field
    name={name}
    render={({ field, form }) => (
      <FormControlLabel
        style={{ marginLeft: 0 }}
        control={(
          <Checkbox
            checked={!!checked}
            onChange={() => form.setFieldValue(field.name, !field.value)}
          />
        )}
        label={label}
      />
    )}
  />
);
